module.exports = __webpack_public_path__ + "static/media/riskcase1.ebec5b76.png";